import { CompareProducts } from '@iheartjane/menu';
import { useRef } from 'react';

import {
  useCompareBarDismissal,
  useIsCompareBarRevealed,
} from '@jane/bloom/components/compareProducts/compareBarVisibility';

interface CompareBarProps {
  /** Keep the bar off screen until a control reveals it. Used on mobile PDP */
  collapsed?: boolean;
}

export const CompareBar = ({ collapsed = false }: CompareBarProps) => {
  const barRef = useRef<HTMLDivElement>(null);
  const isRevealed = useIsCompareBarRevealed();

  useCompareBarDismissal(barRef);

  return (
    <div ref={barRef}>
      <CompareProducts.Bar hidden={collapsed && !isRevealed} />
    </div>
  );
};
